<template>
    <div>
        <transition name="fade" mode="out-in">
            <div :key="currentContent" class="content-box">
                <div v-for="slotName in slotNames" :key="slotName">
                    <template v-if="shouldShowSlot(slotName)">
                        <slot :name="slotName"></slot>
                    </template>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        currentContent: String,
    },
    computed: {
        slotNames() {
            return Object.keys(this.$slots)
        }
    },
    methods: {
        shouldShowSlot(slotName) {
            return this.currentContent === slotName
        }
    }
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>